import { CandidateModel } from '../candidate.model';
import { GroupModel } from '../group.model';
import { SlotModel } from "../slot.model";

export interface AcStatusType {
  base?: AcStatusBaseType;
  settings?: AcStatusSettingsType;
  timing?: { [key: string]: AcStatusTimingsType }; // key = slot_id + candidate/group_hash
  users?: { [key: string]: AcStatusUserType }; // key = hashed_id
}

export interface AcStatusBaseType {
  status: AcTimingStatus | null;
  startedAt?: string | null;
  finishedAt?: string | null;
}

export interface AcStatusSettingsType {
  exercises?: { [key: number | string]: AcStatusSettingsExerciseType | null };
}

export interface AcStatusSettingsExerciseType {
  automatic_start?: boolean;
  has_matrix?: boolean;
  groups?: { [key: string]: AcStatusSettingsExerciseGroupType }; // key = hash
  candidates?: { [key: string]: AcStatusSettingsExerciseCandidateType | null }; // key = hashed_id; value is null if in stock
  observers?: { [key: string]: AcStatusSettingsExerciseObserverType | null }; // key = hashed_id; value is null if in stock
  slots?: { [key: number | string]: AcStatusSettingsExerciseSlotType };
}

export interface AcStatusSettingsExerciseGroupType {
  name?: string;
  moderator?: string | null; // hashed_id
}

export interface AcStatusSettingsExerciseCandidateType {
  group?: string | null;
  sequence?: number;
  observers?: Array<string> | null; // hashed_id - null means all
}

export interface AcStatusSettingsExerciseObserverType {
  group?: string | null;
}

export interface AcStatusSettingsExerciseSlotType {
  duration?: number | null;
  rating_duration?: number | null;
  permissions: { [key: number | string]: Array<string> };
}

export interface AcStatusTimingsType {
  exercise?: AcStatusTimingType;
  rating?: AcStatusTimingType;
  moderator?: string; // hashed_id
  last_action_from?: string; // hashed_id
}

export interface AcStatusTimingType {
  status: SlotStatus | null;
  startedAt?: string | null;
  finishedAt?: string | null;
  pausedAt?: string | null;
  elapsedSeconds?: number | null;
}

export interface AcStatusUserType {
  nav: string | null;
  slot: number | null;
  element: number | null;
  is_online?: boolean;
  timezone?: string | null;
  tz_offset?: string | null;
  avatar?: string | null;
}

// transport interface for active timings

export interface ActiveTiming {
  hash: string;
  slot: SlotModel;
  timing: AcStatusTimingsType;
}

// busy informations

export interface BusyType {
  slot: SlotModel;
  group? : GroupModel;
  mode?: TimerType;
  candidate?: CandidateModel;
}

// enums

export enum AcTimingStatus {
  Planned = 'planned',
  Running = 'running',
  Finished = 'finished',
  Cancelled = 'cancelled',
}

export enum ExerciseStatus {
  Running = 'running',
  Finished = 'finished',
}

export enum SlotStatus {
  Running = 'running',
  Paused = 'paused',
  Finished = 'finished',
}

export enum AcUsertype {
  Candidate = 'candidate',
  Observer = 'observer',
  Moderator = 'moderator',
}

export enum TimerType {
  Exercise = 'exercise',
  Rating = 'rating',
}

export enum RatingstartType {
  None = 'none',
  Start = 'start',
  End = 'end',
}

/**

{
  "base": {
    "status": "running",
    "startedAt": "2023-08-08T08:27:56.302Z",
    "finishedAt": null
  },
  "settings": {
    "exercises": {
      "1": {
        "status": "running",
        "has_matrix": true,
        "automatic_start": true,
        "groups": {
          "1": {
            "name": "Gruppe 1",
            "moderator": 1
          }
        },
        "candidates": {
          "249db500c201083c7aff74c64ec14312": {
            "group": 1,
            "observers": [
              "6d00767c24a463dd402743942d4e384f",
              "aad0a6adece384fe75915bc074b31727"
            ]
          }
        },
        "observers": {
          "6d00767c24a463dd402743942d4e384f": {
            "group": 1,
            "candidates": [
              "249db500c201083c7aff74c64ec14312",
              "f40d2a0e38ebd2b2a39233afdecfcd29"
            ]
          }
        },
        "slots": {
          "930": {
            "duration": 30,
            "permissions": {
              "28": [
                "candidate",
                "observer",
                "moderator"
              ]
            }
          }
        }
      },
      "2": null
    }
  },
  "timing": {
    "249db500c201083c7aff74c64ec14312": {
      "slots": {
        "930": {
          "status": null,
          "startedAt": null,
          "finishedAt": null,
          "pausedAt": null,
          "elapsedSeconds": 0,
          "ratingStatus": null,
          "ratingStartedAt": null,
          "ratingPausedAt": null,
          "ratingFinishedAt": null,
          "ratingElapsedSeconds": 0,
          "moderator": "f40d2a0e38ebd2b2a39233afdecfcd29",
          "last_action_from": "6d00767c24a463dd402743942d4e384f"
        }
      }
    }
  },
  "users": {
    "249db500c201083c7aff74c64ec14312": {
      "type": "candidate",
      "online": "2023-08-08T08:27:56.302Z",
      "slot": "123",
      "element": "234"
    }
  }
}
 */
